import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useVideo } from "../../../../../context/juno/VideoContext";
import { ColumnBox } from "../../../../../utils/styledBox";
import {
  isDurationSliderDisabledForEngine,
  shouldForceDuration,
} from "../../../../../utils/validation/videoValidation";
import AspectRatioIcons from "../AspectRatioIcons";
import ModelVersionSelectBox from "../ModelVersionSelectBox";
import ImageUpload from "../ImageUpload";

const ParamsGoogle = () => {
  const { t } = useTranslation();
  const { updateParams, duration, menu, image1, setImage1, modelVersion, generateAudio, setGenerateAudio } = useVideo();

  const aspectRatio = ["16:9", "9:16"];

  const durationMarks = [
    {
      value: 5,
      label: "5s",
    },
    {
      value: 6,
      label: "6s",
    },
    {
      value: 7,
      label: "7s",
    },
    {
      value: 8,
      label: "8s",
    },
  ];

  // モデルに応じて動画の長さを強制
  useEffect(() => {
    const forceDuration = shouldForceDuration("GOOGLE", modelVersion.GOOGLE);
    if (forceDuration.shouldForce && duration.GOOGLE !== forceDuration.forcedValue) {
      updateParams("GOOGLE", "duration", forceDuration.forcedValue);
    }
  }, [modelVersion.GOOGLE, duration.GOOGLE, updateParams]);

  return (
    <ColumnBox sx={{ gap: 4 }}>
      <ColumnBox>
        {/* Model */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.ai.model")}
        </Typography>
        <ModelVersionSelectBox onChange={(value) => updateParams("GOOGLE", "modelVersion", value)} />
      </ColumnBox>

      <ColumnBox>
        {/* Duration */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.duration")}
        </Typography>
        <Slider
          aria-label="duration"
          marks={durationMarks}
          min={5}
          max={8}
          step={1}
          value={duration.GOOGLE}
          onChange={(_, value) => updateParams("GOOGLE", "duration", value)}
          disabled={isDurationSliderDisabledForEngine("GOOGLE", modelVersion.GOOGLE, menu)}
        />
      </ColumnBox>

      {/* Image */}
      {menu === "i2v" && (
        <ColumnBox sx={{ justifyContent: "center" }}>
          <Typography variant="body2" mb={1}>
            {t("juno.video.params.upload")}
          </Typography>
          <ImageUpload image={image1} setImage={setImage1} />
        </ColumnBox>
      )}

      {/* VEO3 Audio Generation */}
      {modelVersion.GOOGLE === "VEO3" && (
        <ColumnBox>
          <FormControlLabel
            control={
              <Switch checked={generateAudio} onChange={(e) => setGenerateAudio(e.target.checked)} color="primary" />
            }
            label={t("juno.video.params.generateAudio")}
          />
        </ColumnBox>
      )}

      <ColumnBox>
        {/* aspect */}
        <AspectRatioIcons aspectRatioList={aspectRatio} />
      </ColumnBox>
    </ColumnBox>
  );
};

export default ParamsGoogle;
